import type { ReactNode } from "react";
import { Spinner, Text, Button } from "../../theme/primitives";

interface CenteredProps {
  children: ReactNode;
}

function Centered({ children }: CenteredProps) {
  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "var(--space-lg)",
        padding: "var(--space-xl)",
        textAlign: "center",
        background: "var(--color-bg-subtle)",
      }}
    >
      {children}
    </div>
  );
}

export function ConnectingScreen() {
  return (
    <Centered>
      <Spinner size={36} />
      <Text muted>Connecting to your chat…</Text>
    </Centered>
  );
}

export function NoSessionScreen() {
  return (
    <Centered>
      <Text size="xl" weight="bold">
        No active session
      </Text>
      <Text muted style={{ maxWidth: 360 }}>
        This chat opens from your app with a secure one-time link. Please launch it again
        from there to start messaging.
      </Text>
    </Centered>
  );
}

interface ErrorScreenProps {
  message: string;
}

export function ErrorScreen({ message }: ErrorScreenProps) {
  return (
    <Centered>
      <Text size="xl" weight="bold">
        Couldn&apos;t start chat
      </Text>
      <Text muted style={{ maxWidth: 380 }}>
        {message}
      </Text>
      <Text muted size="sm" style={{ maxWidth: 380 }}>
        Your secure link may have expired or already been used. Please reopen the chat
        from your app to get a fresh link.
      </Text>
      <Button variant="ghost" onClick={() => window.location.reload()}>
        Try again
      </Button>
    </Centered>
  );
}
